<div class="modal-container">
  <div class="modal-header">
    <h5 class="modal-title">Add User</h5>
  </div>

  <div class="modal-body">
    @if (successMessage) {
      <div class="success-message-box">
        <div class="success-icon">
          <i class="bi bi-check-circle"></i>
        </div>
        <h3>Success</h3>
        <p>
          The user has been created.<br />{{successMessage}}
        </p>

        <button class="copy-password-btn" (click)="copyTempPassword()">
          <i class="bi bi-clipboard"></i> Copy Temporary Password
        </button>
      </div>
    } @else if (errorMessage) {
      <div class="alert alert-danger" role="alert">
        <strong>Error:</strong> {{ errorMessage }}
      </div>
    } @else {
      <!-- Disable autocomplete at the form level -->
      <form #userForm="ngForm" autocomplete="off">
        <!-- User Type Dropdown -->
        <div ngbDropdown class="dropdown form-group">
          <button
            class="btn dropdown-toggle user-type-dropdown"
            id="userTypeDropdown"
            ngbDropdownToggle
            [ngClass]="{
              'is-invalid': userTypeField.invalid && userTypeField.touched
            }"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
          >
            {{ USER_ROLE_MAPPING[user.userType] || "Select User Type" }}
          </button>
          <div
            ngbDropdownMenu
            class="user-type-options"
            aria-labelledby="userTypeDropdown"
          >
            <button
              class="dropdown-item"
              *ngFor="let role of userRoles"
              (click)="selectUserType(role)"
            >
              {{ USER_ROLE_MAPPING[role] }}
            </button>
          </div>
        </div>

        <!-- Hidden Select Input for Validation -->
        <select
          class="d-none"
          [(ngModel)]="user.userType"
          name="userType"
          required
          #userTypeField="ngModel"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="none"
          spellcheck="false"
        >
          <option *ngFor="let role of userRoles" [value]="role">
            {{ USER_ROLE_MAPPING[role] }}
          </option>
        </select>

        <!-- Validation Message -->
        <div
          class="error-message"
          *ngIf="userTypeField.invalid && userTypeField.touched"
        >
          User Type is required.
        </div>

        <!-- Email Row -->
        <div class="form-group">
          <input
            id="abcd"
            name="abcd"
            type="text"
            class="form-control"
            ngbInput
            placeholder="Enter email"
            [(ngModel)]="user.email"
            name="formMail"
            required
            email
            #emailField="ngModel"
          />
          <div
            class="error-message"
            *ngIf="emailField.invalid && emailField.touched"
          >
            Valid email is required.
          </div>
        </div>

        <!-- Temporary Password Row -->
        <div class="form-group">
          <div class="password-input">
            <input
              id="tempabcd"
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              ngbInput
              placeholder="Enter temporary password"
              [(ngModel)]="user.tempPassword"
              name="tempabcd"
              required
              minlength="8"
              pattern="^(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$"
              #passwordField="ngModel"
              autocomplete="new-password"
              autocorrect="off"
              autocapitalize="none"
              spellcheck="false"
            />
            <i
              class="toggle-password-icon bi"
              [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"
              (click)="togglePasswordVisibility()"
            ></i>
          </div>
          <div
            class="error-message"
            *ngIf="passwordField.invalid && passwordField.touched"
          >
            <span *ngIf="passwordField.errors?.['required']"
              >Password is required.</span
            >
            <span *ngIf="passwordField.errors?.['minlength']"
              >Password must be at least 8 characters.</span
            >
            <span *ngIf="passwordField.errors?.['pattern']">
              Password must contain at least one uppercase letter and one
              symbol.
            </span>
          </div>
        </div>

        <!-- Phone Number Row -->
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            ngbInput
            placeholder="Enter phone number"
            [(ngModel)]="user.phone"
            name="formPhone"
            autocomplete="new-phone"
            autocorrect="off"
            autocapitalize="none"
            spellcheck="false"
          />
        </div>

        <!-- First Name & Last Name Row -->
        <div class="form-row">
          <div class="form-group col">
            <input
              type="text"
              class="form-control"
              ngbInput
              placeholder="Enter first name"
              [(ngModel)]="user.firstName"
              name="formFName"
              required
              #firstNameField="ngModel"
              autocomplete="new-fname"
              autocorrect="off"
              autocapitalize="none"
              spellcheck="false"
            />
            <div
              class="error-message"
              *ngIf="firstNameField.invalid && firstNameField.touched"
            >
              First name is required.
            </div>
          </div>

          <div class="form-group col">
            <input
              type="text"
              class="form-control"
              ngbInput
              placeholder="Enter last name"
              [(ngModel)]="user.lastName"
              name="formLName"
              required
              #lastNameField="ngModel"
              autocomplete="new-lname"
              autocorrect="off"
              autocapitalize="none"
              spellcheck="false"
            />
            <div
              class="error-message"
              *ngIf="lastNameField.invalid && lastNameField.touched"
            >
              Last name is required.
            </div>
          </div>
        </div>
      </form>
    }
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="closeModal()">
      Close
    </button>
    @if (!errorMessage && !successMessage) {
      <button
        class="btn btn-primary add-user-button"
        [disabled]="(userForm && userForm.invalid) || loading"
        (click)="submitUser()"
      >
        <span *ngIf="loading">Adding...</span>
        <span *ngIf="!loading">Add</span>
      </button>
    }
  </div>
</div>